// Variant-level backorder / pre-order display helper
(function () {
  var BACKORDER_KEYWORDS = ['backorder', 'back order', 'back-order'];
  var PREORDER_KEYWORDS = ['preorder', 'pre order', 'pre-order'];

  var lastAvailability = null;
  var lastVariantId = null;
  var pendingTimer = null;

  function textIncludesAny(text, keywords) {
    if (!text) return false;
    var t = String(text).toLowerCase();
    for (var i = 0; i < keywords.length; i += 1) {
      if (t.indexOf(keywords[i]) !== -1) return true;
    }
    return false;
  }

  function getProductJSON() {
    if (window.PRODUCT_JSON && window.PRODUCT_JSON.variants) {
      return window.PRODUCT_JSON;
    }

    var el =
      document.getElementById('ProductJSON-Bridge') ||
      document.querySelector('script[type="application/json"][id^="ProductJson-"]') ||
      document.querySelector('script[type="application/json"][id*="Product"]') ||
      document.querySelector('script[type="application/json"][data-product]');

    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariantById(product, variantId) {
    if (!product || !product.variants || !variantId) return null;

    for (var i = 0; i < product.variants.length; i += 1) {
      if (String(product.variants[i].id) === String(variantId)) {
        return product.variants[i];
      }
    }

    return null;
  }

  function getVariantIdFromForm() {
    var idField = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return idField && idField.value ? idField.value : null;
  }

  function getVariantFromOptionSelectors(product) {
    if (!product || !product.variants) return null;

    var selectors = document.querySelectorAll('.single-option-selector');
    if (!selectors.length) return null;

    var selectedOptions = [];
    for (var i = 0; i < selectors.length; i += 1) {
      selectedOptions.push(selectors[i].value);
    }

    for (var v = 0; v < product.variants.length; v += 1) {
      var variant = product.variants[v];
      var matched = true;

      for (var o = 0; o < selectedOptions.length; o += 1) {
        var optionValue = variant.options ? variant.options[o] : variant['option' + (o + 1)];
        if (optionValue !== selectedOptions[o]) {
          matched = false;
          break;
        }
      }

      if (matched) return variant;
    }

    return null;
  }

  function getCurrentVariant(product, forcedVariant) {
    if (forcedVariant && forcedVariant.id) return forcedVariant;
    if (!product || !product.variants) return null;

    var formVariant = findVariantById(product, getVariantIdFromForm());
    if (formVariant) return formVariant;

    var optionVariant = getVariantFromOptionSelectors(product);
    if (optionVariant) return optionVariant;

    try {
      var urlVariantId = new URLSearchParams(window.location.search).get('variant');
      var urlVariant = findVariantById(product, urlVariantId);
      if (urlVariant) return urlVariant;
    } catch (e) {}

    return product.variants[0] || null;
  }

  function forceVariantEverywhere(variantId) {
    var cartIdField = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (cartIdField && cartIdField.value !== String(variantId)) {
      cartIdField.value = variantId;
    }

    var inputs = document.querySelectorAll('input[name="variant"], input[name="variant_id"], input[data-variant]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (inputs[i].value !== String(variantId)) {
        inputs[i].value = variantId;
      }
    }

    var variantEls = document.querySelectorAll('[data-variant-id]');
    for (var j = 0; j < variantEls.length; j += 1) {
      if (variantEls[j].getAttribute('data-variant-id') !== String(variantId)) {
        variantEls[j].setAttribute('data-variant-id', variantId);
      }
    }
  }

function hasScheduledShippingTitle() {
  var titleEl = document.querySelector('.product-single__title, h1');
  var title = titleEl ? titleEl.textContent : document.title;

  return /\b(?:ships|shipping)\b/i.test(title || '');
}

function getAvailabilityType(variant) {
  if (!variant) return null;

  /*
   * Product-level tags take priority.
   * This keeps normal pre-order/backorder products behaving exactly
   * as they do now, even if their title also contains "Ships".
   */
  var tags = Array.isArray(window.producttags)
    ? window.producttags.map(function (tag) {
        return String(tag).toLowerCase();
      })
    : [];

  if (tags.indexOf('backorder') !== -1) return 'backorder';
  if (tags.indexOf('pre-order') !== -1) return 'preorder';

  var fields = [
    variant.title,
    variant.option1,
    variant.option2,
    variant.option3
  ];

  var isBackorder = fields.some(function (f) {
    return textIncludesAny(f, BACKORDER_KEYWORDS);
  });

  var isPreorder = fields.some(function (f) {
    return textIncludesAny(f, PREORDER_KEYWORDS);
  });

  if (isBackorder) return 'backorder';
  if (isPreorder) return 'preorder';

  /*
   * A product title containing "Ships" or "Shipping" means the item
   * should not be treated as ordinary on-hand inventory.
   */
  if (hasScheduledShippingTitle()) return 'scheduled';

  return null;
}

  function setDisplay(el, shouldShow) {
    if (!el) return;
    el.style.display = shouldShow ? '' : 'none';
  }

  function updateVisibleForm(type, variant) {
    var autoMessage = document.getElementById('outofstock_message_auto');

    // Variant-labeled pre-order/backorder alerts now use the dedicated A46
    // popup. Do not inject the legacy Shopify contact forms here.
    if (type === 'backorder' || type === 'preorder') {
      if (autoMessage) {
        autoMessage.style.display = 'none';
        autoMessage.innerHTML = '';
      }
    } else if (variant && !variant.available) {
      if (autoMessage) {
        autoMessage.style.display = '';
        autoMessage.innerHTML = '<a class="btn klaviyo-bis-trigger" href="#">Notify me when available</a>';
      }
    } else if (autoMessage) {
      autoMessage.style.display = 'none';
      autoMessage.innerHTML = '';
    }
  }

function updatePurchaseArea(type, variant) {
  var addButton = document.querySelector('[id^="AddToCart-"]');
  var addText = document.querySelector('[id^="AddToCartText-"]');
  var quantityMessage = document.getElementById('quantity_message');

  if (!variant) return;

  if (addButton) {
    addButton.disabled = !variant.available;
  }

  if (addText) {
    if (type === 'backorder' && variant.available) {
      addText.textContent = 'Reserve Now!';
    } else if (type === 'preorder' && variant.available) {
      addText.textContent = 'Pre-Order Now!';
    } else if (type === 'scheduled' && variant.available) {
      addText.textContent = 'Reserve Now!';
    } else if (!variant.available) {
      addText.textContent =
        (window.theme && theme.strings && theme.strings.soldOut)
          ? theme.strings.soldOut
          : 'Sold Out';
    } else {
      addText.textContent =
        (window.theme && theme.strings && theme.strings.addToCart)
          ? theme.strings.addToCart
          : 'Add to Cart';
    }
  }

  if (!quantityMessage) return;

  if ((type === 'backorder' || type === 'preorder') && variant.available) {
    var quantity = document.getElementById('pvr-' + variant.id);
    var quantityText = quantity ? quantity.textContent : '';

    quantityMessage.style.display = '';
    quantityMessage.innerHTML =
      'AVAILABLE TO RESERVE<br>' +
      '<progress value="20" max="20" aria-label="Available to reserve"></progress>';
  } else if (type === 'scheduled' && variant.available) {
    quantityMessage.style.display = '';
    quantityMessage.innerHTML =
      'AVAILABLE TO RESERVE<br>' +
      '<progress value="20" max="20" aria-label="Available to reserve"></progress>';
  } else if (type === 'scheduled') {
    quantityMessage.style.display = '';
    quantityMessage.innerHTML =
      'OUT OF STOCK<br>' +
      '<progress value="0" max="20" aria-label="Out of stock"></progress>';
  }
}

  function evaluateAvailability(forcedVariant) {
    var product = getProductJSON();
    if (!product) return;

    var variant = getCurrentVariant(product, forcedVariant);
    if (!variant) return;

    var availability = getAvailabilityType(variant);

    window.__AVAILABILITY_STATE__ = {
      type: availability,
      variantId: variant.id,
      variantTitle: variant.title
    };

    if (availability === lastAvailability && String(variant.id) === String(lastVariantId)) {
      return;
    }

    lastAvailability = availability;
    lastVariantId = variant.id;

    forceVariantEverywhere(variant.id);
    updateVisibleForm(availability, variant);
    updatePurchaseArea(availability, variant);
    // The A46 popup listens for selected-variant changes on products whose
    // individual options say pre-order or backorder, rather than product tags.
    document.dispatchEvent(new CustomEvent('a46:availability-change', {
      detail: window.__AVAILABILITY_STATE__
    }));
  }

  function scheduleEvaluate(forcedVariant) {
    if (pendingTimer) window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(function () {
      evaluateAvailability(forcedVariant);
      pendingTimer = null;
    }, 30);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-back-in-stock], .back-in-stock, .notify-me, .klaviyo-bis-trigger');
    if (!btn) return;

    var product = getProductJSON();
    if (!product) return;

    var variant = getCurrentVariant(product);
    if (!variant) return;

    forceVariantEverywhere(variant.id);
  });

  document.addEventListener('change', function (e) {
    if (!e.target) return;

    if (
      e.target.matches('.single-option-selector') ||
      e.target.matches('.swatch input') ||
      e.target.matches('form[action*="/cart/add"] [name="id"]')
    ) {
      scheduleEvaluate();
    }
  }, true);

  document.addEventListener('variant:change', function (e) {
    scheduleEvaluate(e.detail && e.detail.variant ? e.detail.variant : null);
  });

  if (window.jQuery) {
    window.jQuery(document).on('variantChange', function (evt) {
      scheduleEvaluate(evt && evt.variant ? evt.variant : null);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleEvaluate();
  });

  scheduleEvaluate();
})();